import LocalizedStrings, { LocalizedStringsMethods } from 'react-localization';
import enUS from './locales/en-us';
import enCA from './locales/en-ca';
import enAU from "./locales/en-au";
import enGB from "./locales/en-gb";

export interface ILocalizedStrings extends LocalizedStringsMethods {
    Errors?: {
        serverError?: string;
    };
    App?: {
        unauthorized?: string;
    };
    HomeView?: {
        title?: string;
        headerAltText?: string;
        footerAltText?: string;
        uhfexplanation?: string;
        howUhfWorks?: string;
        howUhfWorksTextOne?: string;
        howUhfWorksTextTwo?: string;
        linkBoxOne?: string;
        linkBoxOneText?: string;
        linkBoxOneLinkText?: string;
        linkBoxOneImageAltText?: string;
        linkBoxTwo?: string;
        linkBoxTwoText?: string;
        linkBoxTwoLinkText?: string;
        linkBoxTwoImageAltText?: string;
        linkBoxThree?: string;
        linkBoxThreeText?: string;
        linkBoxThreeLinkText?: string;
        linkBoxThreeImageAltText?: string;
        linkBoxFour?: string;
        linkBoxFourText?: string;
        linkBoxFourLinkText?: string;
        linkBoxFourImageAltText?: string;
    };
    TestView?: {
        TestConfigurator?: {
            environment?: string;
            footerId?: string;
            headerId?: string;
            serviceLink?: string;
            locale?: string;
            options?: string;
            partnerId?: string;
            title?: string;
            description?: string;
            openInNewWindow?: string;
        };
    };
    AdminView?: {
        Unauthorized?: {
            title?: string;
            description?: string;
        };
    };
}

export const localizedStrings: ILocalizedStrings = new LocalizedStrings({
    "en-us": enUS,
    "en-ca": enCA,
    "en-gb": enGB,
    "en-au": enAU
});